import styles from './dashboard.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';
import RetinaImage from 'src/components/RetinaImage';
import FeaturesLinksSection from 'src/components/FeaturesLinksSection';
import ReportTypesGrid from 'src/components/ReportTypesGrid';
import ReportingUseCasesSection from 'src/components/ReportingUseCasesSection';
import UptimeSplash from 'src/components/UptimeSplash';

import ImgIphoneReporting from 'src/images/img-iphone-reporting.png';
import ImgIphoneReporting2x from 'src/images/img-iphone-reporting@2x.png';
import ImgIphoneReporting3x from 'src/images/img-iphone-reporting@3x.png';
import IconReporting from 'src/images/icon-reporting.png';
import IconReporting2x from 'src/images/icon-reporting@2x.png';
import IconReporting3x from 'src/images/icon-reporting@3x.png';

const Hero = (props) => (
  <div styleName='hero'>
      <Container>
          <div styleName='text-container'>
              <RetinaImage srcSet={[IconReporting, IconReporting2x, IconReporting3x]} />
              <div className='h1 mt-2'>Reporting</div>
              <div className='h2 text-blue'>
                  All the data you need, right at your fingertips.
              </div>
              <div styleName='message'>
                  Galleon comes ready with dozens of pre-built reports. Not
                  finding what you need? Our team of data engineers is on call to
                  build additional custom reports, on-demand.
              </div>
              <ButtonLink styleName='button' to='/contact'>
                  Try free for 7 days
              </ButtonLink>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgIphoneReporting, ImgIphoneReporting2x, ImgIphoneReporting3x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);

export default (props) => (
  <div>
      <Hero />
      <ReportTypesGrid />
      <ReportingUseCasesSection />
      <UptimeSplash />
      <FeaturesLinksSection />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/features/reporting.js